export const ArrowTopRight = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0037 4.0187L2.39712 12.6253L0.98291 11.2111L9.5895 2.60449H2.00373V0.604492H13.0037V11.6045H11.0037V4.0187Z"
        fill="var(--color)"
      />
    </svg>
  );
};

export const Download = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 12.9507V16.284C17.5 16.726 17.3244 17.15 17.0118 17.4625C16.6993 17.7751 16.2754 17.9507 15.8333 17.9507H4.16667C3.72464 17.9507 3.30072 17.7751 2.98816 17.4625C2.67559 17.15 2.5 16.726 2.5 16.284V12.9507"
        stroke="var(--color)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83301 8.78406L9.99967 12.9507L14.1663 8.78406"
        stroke="var(--color)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.9507V2.95068"
        stroke="var(--color)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronRight = ({ color, ...rest }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9 18L15 12L9 6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowRight = () => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5303 6.13458C12.8232 5.84169 12.8232 5.36681 12.5303 5.07392L7.75736 0.300948C7.46447 0.00805462 6.98959 0.00805458 6.6967 0.300948C6.40381 0.593841 6.40381 1.06871 6.6967 1.36161L10.9393 5.60425L6.6967 9.84689C6.40381 10.1398 6.40381 10.6147 6.6967 10.9075C6.98959 11.2004 7.46447 11.2004 7.75736 10.9075L12.5303 6.13458ZM-6.55671e-08 6.35425L12 6.35425L12 4.85425L6.55671e-08 4.85425L-6.55671e-08 6.35425Z"
        fill="var(--color)"
      />
    </svg>
  );
};

export const Calculate = () => {
  return (
    <img
      src="/static/icons/calculate.svg"
      width="24"
      height="24"
      alt=""
      draggable="false"
    />
  );
};

export const Phone = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22.0004 16.9201V19.9201C22.0016 20.1986 21.9445 20.4743 21.8329 20.7294C21.7214 20.9846 21.5577 21.2137 21.3525 21.402C21.1473 21.5902 20.905 21.7336 20.6412 21.8228C20.3773 21.912 20.0978 21.9452 19.8204 21.9201C16.7433 21.5857 13.7874 20.5342 11.1904 18.8501C8.77425 17.3148 6.72576 15.2663 5.19042 12.8501C3.5004 10.2413 2.44866 7.27109 2.12042 4.1801C2.09543 3.90356 2.1283 3.62486 2.21692 3.36172C2.30555 3.09859 2.44799 2.85679 2.63519 2.65172C2.82238 2.44665 3.05023 2.28281 3.30421 2.17062C3.5582 2.05843 3.83276 2.00036 4.11042 2.0001H7.11042C7.59573 1.99532 8.06621 2.16718 8.43418 2.48363C8.80215 2.80008 9.0425 3.23954 9.11042 3.7201C9.23704 4.68016 9.47187 5.62282 9.81042 6.5301C9.94497 6.88802 9.97408 7.27701 9.89433 7.65098C9.81457 8.02494 9.62928 8.36821 9.36042 8.6401L8.09042 9.9101C9.51398 12.4136 11.5869 14.4865 14.0904 15.9101L15.3604 14.6401C15.6323 14.3712 15.9756 14.1859 16.3495 14.1062C16.7235 14.0264 17.1125 14.0556 17.4704 14.1901C18.3777 14.5286 19.3204 14.7635 20.2804 14.8901C20.7662 14.9586 21.2098 15.2033 21.527 15.5776C21.8441 15.9519 22.0126 16.4297 22.0004 16.9201Z"
        stroke="var(--color)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Quote = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.64681 15.9949C2.52814 15.9949 0 13.4668 0 10.348C0 7.36137 1.26753 2.83678 3.07511 0.692383L4.96569 1.85206C4.96569 1.85206 4.10061 3.50201 3.9796 4.95143C4.50653 4.78892 5.06664 4.70041 5.64681 4.70041C8.76549 4.70041 11.2936 7.22929 11.2936 10.348C11.2936 13.4668 8.76549 15.9949 5.64681 15.9949ZM18.3525 15.9949C15.2338 15.9949 12.7057 13.4668 12.7057 10.348C12.7057 7.36137 13.9739 2.83678 15.7808 0.692383L17.6721 1.85206C17.6721 1.85206 16.8063 3.50201 16.686 4.95143C17.2122 4.78892 17.7723 4.70041 18.3525 4.70041C21.4719 4.70041 24 7.22929 24 10.348C24 13.4668 21.4719 15.9949 18.3525 15.9949Z"
        fill="#300D00"
        fill-opacity="0.51"
      />
    </svg>
  );
};

export const Frame = () => {
  return (
    <img
      src="/static/icons/frame.svg"
      width="32"
      height="33"
      alt=""
      draggable="false"
    />
  );
};

export const Code = () => {
  return (
    <img
      src="/static/icons/code.svg"
      width="32"
      height="33"
      alt=""
      draggable="false"
    />
  );
};

export const Comment = () => {
  return (
    <img
      src="/static/icons/comment.svg"
      width="32"
      height="33"
      alt=""
      draggable="false"
    />
  );
};

export const SiteWebAndApp = () => {
  return (
    <img
      src="/static/icons/site-web-app.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const RenfortEquipe = () => {
  return (
    <img
      src="/static/icons/renfort-equipe.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const BrandingDesign = () => {
  return (
    <img
      src="/static/icons/branding-design.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const FormationConseil = () => {
  return (
    <img
      src="/static/icons/formation-conseil.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const ChevronDown = ({ ...rest }) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.68478 1.05953L5.30977 5.43453C5.26914 5.47521 5.22089 5.50748 5.16778 5.52949C5.11467 5.55151 5.05774 5.56284 5.00024 5.56284C4.94275 5.56284 4.88582 5.55151 4.83271 5.52949C4.7796 5.50748 4.73134 5.47521 4.69071 5.43453L0.315712 1.05953C0.233619 0.977438 0.1875 0.866096 0.1875 0.749999C0.1875 0.633902 0.233619 0.52256 0.315712 0.440468C0.397805 0.358375 0.509147 0.312256 0.625243 0.312256C0.74134 0.312256 0.852682 0.358375 0.934774 0.440468L5.00024 4.50648L9.06571 0.440468C9.10636 0.399819 9.15462 0.367576 9.20773 0.345577C9.26084 0.323578 9.31776 0.312256 9.37524 0.312256C9.43273 0.312256 9.48965 0.323578 9.54276 0.345577C9.59587 0.367576 9.64413 0.399819 9.68478 0.440468C9.72542 0.481116 9.75767 0.529372 9.77967 0.582482C9.80166 0.635591 9.81299 0.692514 9.81299 0.749999C9.81299 0.807484 9.80166 0.864407 9.77967 0.917516C9.75767 0.970626 9.72542 1.01888 9.68478 1.05953Z"
        fill="var(--color)"
      />
    </svg>
  );
};

export const Ai = ({ ...rest }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_700_7765)">
        <path
          d="M12.75 2.34473V5.34473C12.75 5.54364 12.671 5.7344 12.5303 5.87506C12.3897 6.01571 12.1989 6.09473 12 6.09473C11.8011 6.09473 11.6103 6.01571 11.4697 5.87506C11.329 5.7344 11.25 5.54364 11.25 5.34473V2.34473C11.25 2.14581 11.329 1.95505 11.4697 1.8144C11.6103 1.67374 11.8011 1.59473 12 1.59473C12.1989 1.59473 12.3897 1.67374 12.5303 1.8144C12.671 1.95505 12.75 2.14581 12.75 2.34473ZM16.5 6.09473C16.3011 6.09473 16.1103 6.17374 15.9697 6.3144C15.829 6.45505 15.75 6.64581 15.75 6.84473V9.84473C15.75 10.0436 15.829 10.2344 15.9697 10.3751C16.1103 10.5157 16.3011 10.5947 16.5 10.5947C16.6989 10.5947 16.8897 10.5157 17.0303 10.3751C17.171 10.2344 17.25 10.0436 17.25 9.84473V6.84473C17.25 6.64581 17.171 6.45505 17.0303 6.3144C16.8897 6.17374 16.6989 6.09473 16.5 6.09473ZM12 19.5947C11.8011 19.5947 11.6103 19.6737 11.4697 19.8144C11.329 19.955 11.25 20.1458 11.25 20.3447V23.3447C11.25 23.5436 11.329 23.7344 11.4697 23.8751C11.6103 24.0157 11.8011 24.0947 12 24.0947C12.1989 24.0947 12.3897 24.0157 12.5303 23.8751C12.671 23.7344 12.75 23.5436 12.75 23.3447V20.3447C12.75 20.1458 12.671 19.955 12.5303 19.8144C12.3897 19.6737 12.1989 19.5947 12 19.5947ZM12 8.34473C11.8011 8.34473 11.6103 8.42374 11.4697 8.5644C11.329 8.70505 11.25 8.89581 11.25 9.09473V16.5947C11.25 16.7936 11.329 16.9844 11.4697 17.1251C11.6103 17.2657 11.8011 17.3447 12 17.3447C12.1989 17.3447 12.3897 17.2657 12.5303 17.1251C12.671 16.9844 12.75 16.7936 12.75 16.5947V9.09473C12.75 8.89581 12.671 8.70505 12.5303 8.5644C12.3897 8.42374 12.1989 8.34473 12 8.34473ZM7.5 6.09473C7.30109 6.09473 7.11032 6.17374 6.96967 6.3144C6.82902 6.45505 6.75 6.64581 6.75 6.84473V12.0947C6.75 12.2936 6.82902 12.4844 6.96967 12.6251C7.11032 12.7657 7.30109 12.8447 7.5 12.8447C7.69891 12.8447 7.88968 12.7657 8.03033 12.6251C8.17098 12.4844 8.25 12.2936 8.25 12.0947V6.84473C8.25 6.64581 8.17098 6.45505 8.03033 6.3144C7.88968 6.17374 7.69891 6.09473 7.5 6.09473ZM16.5 12.8447C16.3011 12.8447 16.1103 12.9237 15.9697 13.0644C15.829 13.205 15.75 13.3958 15.75 13.5947V18.8447C15.75 19.0436 15.829 19.2344 15.9697 19.3751C16.1103 19.5157 16.3011 19.5947 16.5 19.5947C16.6989 19.5947 16.8897 19.5157 17.0303 19.3751C17.171 19.2344 17.25 19.0436 17.25 18.8447V13.5947C17.25 13.3958 17.171 13.205 17.0303 13.0644C16.8897 12.9237 16.6989 12.8447 16.5 12.8447ZM3 10.5947C2.80109 10.5947 2.61032 10.6737 2.46967 10.8144C2.32902 10.955 2.25 11.1458 2.25 11.3447V14.3447C2.25 14.5436 2.32902 14.7344 2.46967 14.8751C2.61032 15.0157 2.80109 15.0947 3 15.0947C3.19891 15.0947 3.38968 15.0157 3.53033 14.8751C3.67098 14.7344 3.75 14.5436 3.75 14.3447V11.3447C3.75 11.1458 3.67098 10.955 3.53033 10.8144C3.38968 10.6737 3.19891 10.5947 3 10.5947ZM7.5 15.0947C7.30109 15.0947 7.11032 15.1737 6.96967 15.3144C6.82902 15.455 6.75 15.6458 6.75 15.8447V18.8447C6.75 19.0436 6.82902 19.2344 6.96967 19.3751C7.11032 19.5157 7.30109 19.5947 7.5 19.5947C7.69891 19.5947 7.88968 19.5157 8.03033 19.3751C8.17098 19.2344 8.25 19.0436 8.25 18.8447V15.8447C8.25 15.6458 8.17098 15.455 8.03033 15.3144C7.88968 15.1737 7.69891 15.0947 7.5 15.0947ZM21 10.5947C20.8011 10.5947 20.6103 10.6737 20.4697 10.8144C20.329 10.955 20.25 11.1458 20.25 11.3447V14.3447C20.25 14.5436 20.329 14.7344 20.4697 14.8751C20.6103 15.0157 20.8011 15.0947 21 15.0947C21.1989 15.0947 21.3897 15.0157 21.5303 14.8751C21.671 14.7344 21.75 14.5436 21.75 14.3447V11.3447C21.75 11.1458 21.671 10.955 21.5303 10.8144C21.3897 10.6737 21.1989 10.5947 21 10.5947Z"
          fill="var(--color)"
        />
      </g>
      <defs>
        <clipPath id="clip0_700_7765">
          <rect
            width="24"
            height="24"
            fill="var(--color)"
            transform="translate(0 0.844727)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Sun = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 3.75V3C11.25 2.80109 11.329 2.61032 11.4697 2.46967C11.6103 2.32902 11.8011 2.25 12 2.25C12.1989 2.25 12.3897 2.32902 12.5303 2.46967C12.671 2.61032 12.75 2.80109 12.75 3V3.75C12.75 3.94891 12.671 4.13968 12.5303 4.28033C12.3897 4.42098 12.1989 4.5 12 4.5C11.8011 4.5 11.6103 4.42098 11.4697 4.28033C11.329 4.13968 11.25 3.94891 11.25 3.75ZM18 12C18 13.1867 17.6481 14.3467 16.9888 15.3334C16.3295 16.3201 15.3925 17.0892 14.2961 17.5433C13.1997 17.9974 11.9933 18.1162 10.8295 17.8847C9.66557 17.6532 8.59647 17.0818 7.75736 16.2426C6.91824 15.4035 6.3468 14.3344 6.11529 13.1705C5.88378 12.0067 6.0026 10.8003 6.45672 9.7039C6.91085 8.60754 7.67988 7.67047 8.66658 7.01118C9.65327 6.35189 10.8133 6 12 6C13.5908 6.00174 15.1159 6.63444 16.2407 7.75928C17.3656 8.88412 17.9983 10.4092 18 12ZM16.5 12C16.5 11.11 16.2361 10.24 15.7416 9.49993C15.2471 8.75991 14.5443 8.18314 13.7221 7.84254C12.8998 7.50195 11.995 7.41283 11.1221 7.58647C10.2492 7.7601 9.44736 8.18868 8.81802 8.81802C8.18868 9.44736 7.7601 10.2492 7.58647 11.1221C7.41283 11.995 7.50195 12.8998 7.84254 13.7221C8.18314 14.5443 8.75991 15.2471 9.49993 15.7416C10.24 16.2361 11.11 16.5 12 16.5C13.1931 16.4988 14.337 16.0243 15.1806 15.1806C16.0243 14.337 16.4988 13.1931 16.5 12ZM5.46938 6.53063C5.61011 6.67136 5.80098 6.75042 6 6.75042C6.19902 6.75042 6.38989 6.67136 6.53063 6.53063C6.67136 6.38989 6.75042 6.19902 6.75042 6C6.75042 5.80098 6.67136 5.61011 6.53063 5.46938L5.78062 4.71938C5.63989 4.57864 5.44902 4.49958 5.25 4.49958C5.05098 4.49958 4.86011 4.57864 4.71938 4.71938C4.57864 4.86011 4.49958 5.05098 4.49958 5.25C4.49958 5.44902 4.57864 5.63989 4.71938 5.78062L5.46938 6.53063ZM5.46938 17.4694L4.71938 18.2194C4.57864 18.3601 4.49958 18.551 4.49958 18.75C4.49958 18.949 4.57864 19.1399 4.71938 19.2806C4.86011 19.4214 5.05098 19.5004 5.25 19.5004C5.44902 19.5004 5.63989 19.4214 5.78062 19.2806L6.53063 18.5306C6.60031 18.4609 6.65558 18.3782 6.6933 18.2872C6.73101 18.1961 6.75042 18.0985 6.75042 18C6.75042 17.9015 6.73101 17.8039 6.6933 17.7128C6.65558 17.6218 6.60031 17.5391 6.53063 17.4694C6.46094 17.3997 6.37822 17.3444 6.28717 17.3067C6.19613 17.269 6.09855 17.2496 6 17.2496C5.90145 17.2496 5.80387 17.269 5.71283 17.3067C5.62178 17.3444 5.53906 17.3997 5.46938 17.4694ZM18 6.75C18.0985 6.75008 18.1961 6.73074 18.2871 6.6931C18.3782 6.65546 18.4609 6.60025 18.5306 6.53063L19.2806 5.78062C19.4214 5.63989 19.5004 5.44902 19.5004 5.25C19.5004 5.05098 19.4214 4.86011 19.2806 4.71938C19.1399 4.57864 18.949 4.49958 18.75 4.49958C18.551 4.49958 18.3601 4.57864 18.2194 4.71938L17.4694 5.46938C17.3644 5.57427 17.2928 5.70796 17.2639 5.85352C17.2349 5.99908 17.2497 6.14998 17.3065 6.28709C17.3633 6.42421 17.4596 6.54139 17.583 6.62379C17.7065 6.70619 17.8516 6.75012 18 6.75ZM18.5306 17.4694C18.3899 17.3286 18.199 17.2496 18 17.2496C17.801 17.2496 17.6101 17.3286 17.4694 17.4694C17.3286 17.6101 17.2496 17.801 17.2496 18C17.2496 18.199 17.3286 18.3899 17.4694 18.5306L18.2194 19.2806C18.2891 19.3503 18.3718 19.4056 18.4628 19.4433C18.5539 19.481 18.6515 19.5004 18.75 19.5004C18.8485 19.5004 18.9461 19.481 19.0372 19.4433C19.1282 19.4056 19.2109 19.3503 19.2806 19.2806C19.3503 19.2109 19.4056 19.1282 19.4433 19.0372C19.481 18.9461 19.5004 18.8485 19.5004 18.75C19.5004 18.6515 19.481 18.5539 19.4433 18.4628C19.4056 18.3718 19.3503 18.2891 19.2806 18.2194L18.5306 17.4694ZM3.75 11.25H3C2.80109 11.25 2.61032 11.329 2.46967 11.4697C2.32902 11.6103 2.25 11.8011 2.25 12C2.25 12.1989 2.32902 12.3897 2.46967 12.5303C2.61032 12.671 2.80109 12.75 3 12.75H3.75C3.94891 12.75 4.13968 12.671 4.28033 12.5303C4.42098 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.42098 11.6103 4.28033 11.4697C4.13968 11.329 3.94891 11.25 3.75 11.25ZM12 19.5C11.8011 19.5 11.6103 19.579 11.4697 19.7197C11.329 19.8603 11.25 20.0511 11.25 20.25V21C11.25 21.1989 11.329 21.3897 11.4697 21.5303C11.6103 21.671 11.8011 21.75 12 21.75C12.1989 21.75 12.3897 21.671 12.5303 21.5303C12.671 21.3897 12.75 21.1989 12.75 21V20.25C12.75 20.0511 12.671 19.8603 12.5303 19.7197C12.3897 19.579 12.1989 19.5 12 19.5ZM21 11.25H20.25C20.0511 11.25 19.8603 11.329 19.7197 11.4697C19.579 11.6103 19.5 11.8011 19.5 12C19.5 12.1989 19.579 12.3897 19.7197 12.5303C19.8603 12.671 20.0511 12.75 20.25 12.75H21C21.1989 12.75 21.3897 12.671 21.5303 12.5303C21.671 12.3897 21.75 12.1989 21.75 12C21.75 11.8011 21.671 11.6103 21.5303 11.4697C21.3897 11.329 21.1989 11.25 21 11.25Z"
        fill="var(--color)"
      />
    </svg>
  );
};

export const Moon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8957 13.334C21.7995 13.2376 21.6789 13.1692 21.5468 13.1362C21.4146 13.1032 21.276 13.1067 21.1457 13.1465C19.7156 13.5789 18.1951 13.6151 16.746 13.2514C15.2969 12.8877 13.9737 12.1377 12.9173 11.0813C11.8608 10.0249 11.1108 8.7016 10.7471 7.25254C10.3834 5.80347 10.4196 4.28288 10.852 2.85279C10.8921 2.72248 10.896 2.5837 10.8631 2.45137C10.8302 2.31903 10.7619 2.19816 10.6655 2.10175C10.5691 2.00534 10.4482 1.93703 10.3159 1.90418C10.1836 1.87132 10.0448 1.87517 9.91449 1.91529C7.93732 2.52096 6.20155 3.73478 4.95417 5.38404C3.86331 6.83234 3.19791 8.55614 3.03273 10.3618C2.86756 12.1674 3.20914 13.9833 4.01912 15.6055C4.8291 17.2277 6.07537 18.5919 7.61792 19.5448C9.16048 20.4978 10.9382 21.0017 12.7514 21C14.8667 21.0065 16.9257 20.3188 18.6126 19.0425C20.2619 17.7951 21.4757 16.0593 22.0814 14.0822C22.121 13.9523 22.1247 13.8142 22.092 13.6824C22.0593 13.5507 21.9915 13.4303 21.8957 13.334ZM17.7107 17.8444C16.1222 19.0408 14.1549 19.6232 12.171 19.4843C10.1871 19.3454 8.32018 18.4945 6.91387 17.0883C5.50756 15.6822 4.65653 13.8153 4.51746 11.8314C4.37838 9.84753 4.96062 7.88019 6.15699 6.29154C6.93643 5.26222 7.94411 4.42784 9.10074 3.85404C9.03485 4.31644 9.00164 4.78291 9.00136 5.24998C9.00409 7.835 10.0322 10.3134 11.8601 12.1413C13.688 13.9691 16.1663 14.9972 18.7514 15C19.2194 14.9998 19.6868 14.9666 20.1501 14.9006C19.5758 16.0574 18.7407 17.0651 17.7107 17.8444Z"
        fill="var(--color)"
      />
    </svg>
  );
};
